<template>
    <div  v-if="activeFilter == 'tutto'" class="review-list">
        <div
            class="review-list__item"
            v-for="review in reviews"
            :key="review.id"
        >
            <review
                :user="review.id"
                :name="review.name"
                :avatar="review.avatar"
                :text="review.pivot.comment"
                :rating="review.pivot.rating"
            />
        </div>
    </div>
    <div  v-if="activeFilter == 'positive'" class="review-list">
        <div
            class="review-list__item"
            v-for="review in reviews"
            :key="review.id"
        >
            <review v-if="review.pivot.rating > 3"
                :name="review.name"
                :avatar="review.avatar"
                :text="review.pivot.comment"
                :rating="review.pivot.rating"
            />
        </div>
    </div>
    <div  v-if="activeFilter == 'critic'" class="review-list">
        <div
            class="review-list__item"
            v-for="review in reviews"
            :key="review.id"
        >
            <review v-if="review.pivot.rating < 3"
                :name="review.name"
                :avatar="review.avatar"
                :text="review.pivot.comment"
                :rating="review.pivot.rating"
            />
        </div>
    </div>
    <div  v-if="activeFilter == '5'" class="review-list">
        <div
            class="review-list__item"
            v-for="review in reviews"
            :key="review.id"
        >
            <review v-if="review.pivot.rating == 5"
                :name="review.name"
                :avatar="review.avatar"
                :text="review.pivot.comment"
                :rating="review.pivot.rating"
            />
        </div>
    </div>
    <div  v-if="activeFilter == '4'" class="review-list">
        <div
            class="review-list__item"
            v-for="review in reviews"
            :key="review.id"
        >
            <review v-if="review.pivot.rating == 4"
                :name="review.name"
                :avatar="review.avatar"
                :text="review.pivot.comment"
                :rating="review.pivot.rating"
            />
        </div>
    </div>
</template>

<script>
import Review from '@/components/review/review';

export default {
    name: 'ReviewList',

    components: {
        Review
    },

    props: {
        reviews: {
            type: Array,
            default: () => ([])
        },
        activeFilter: {
            type: String,
            default: 'tutto'
        }
    }

}
</script>
